import { NgxSpinnerService } from 'ngx-spinner';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { jqxDropDownListComponent } from 'jqwidgets-ng/jqxdropdownlist';
import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { jqxNotificationComponent } from 'jqwidgets-ng/jqxnotification';
import { asyncScheduler, firstValueFrom, Observable, of, zip } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from "src/environments/environment";
import { jqxTextAreaComponent } from 'jqwidgets-ng/jqxtextarea';
import { DatePipe } from '@angular/common';

import Swal from 'sweetalert2';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { BackendService } from 'src/app/services/backend.service';
import { AttachmentsDialogData, CourtLocations, CourtRooms, EstimateDialogData, FileToUpload, Jurisdictions, MediaDialogData, NotesDialogData, OrderInputDto, Organizations } from 'src/app/models/apiRequestModels';
import { UploadOrderMediaComponent } from './upload-order-media/upload-order-media.component';
import { UploadMediaComponent } from 'src/app/upload-job/upload-media/upload-media.component';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { jqxDateTimeInputComponent } from 'jqwidgets-ng/jqxdatetimeinput';
import { FileAccessService } from 'src/app/services/fileaccess.service';
import { UploadAudioFileComponent } from 'src/app/tables/table-list/upload-audiofile/upload-audiofile.component';
import { log } from 'console';
import { jqxListBoxComponent } from 'jqwidgets-ng/jqxlistbox';
import { UserStatus } from 'src/app/models/UserStatus';


declare const $: any;
let departmentList;
let Audiofile = new FileToUpload();
let Attachmentfile = new FileToUpload();
let ListOfOriginalFiles = [];
let ListzipFiles = [];
let ListOfMergeAudioFiles = [];
let MergeAudioFileNameList = [];
let ListOfAttachmentFiles = [];
let ListOfZippedDocuments = [];
let ListOfZipFiles = [];
let Attachmentscount1 = 0;
let MergeAudioFilescount = 0;
let CompleteAudioFilescount = 0;
let CompleteAttachmentscount = 0;

export interface dropdownmodel {
  id: string;
  name: string;
  orderFormTypes: string;
  formName: string
}
@Component({
  selector: 'app-upload-court-order',
  templateUrl: './upload-court-order.component.html',
  styleUrls: ['./upload-court-order.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class UploadCourtOrderComponent implements OnInit {
  title = 'Create Order';
  progress: number;
  departmentControl = new FormControl();
  jobtypeControl = new FormControl();
  formtypeControl = new FormControl();
  authorControl = new FormControl();
  requestorControl = new FormControl();
  Sensitive = new FormControl();
  defaultRadioButtonControl = new FormControl();
  CertificateRequired = new FormControl();
  languageControl = new FormControl();
  jurisdictionControl = new FormControl();
  courtLocationControl = new FormControl();
  courtRoomControl = new FormControl();
  orderTypeControl = new FormControl();
  departmentOptions: any[];
  deptfilteredOptions: Observable<dropdownmodel[]>;
  jobTypeOptions: any[];
  jobTypefilteredOptions: Observable<dropdownmodel[]>;
  formTypeOptions: any[];
  formTypefilteredOptions: Observable<dropdownmodel[]>;
  authorOptions: any[];
  authorfilteredOptions: Observable<dropdownmodel[]>;
  orderCreationForm: FormGroup;
  selectedFormTypeId: number;
  selectedJobTypeExtId = "";
  selectedJobTypeDisplayName = "";
  selectedDepartmentId = "";
  selectedDeptExtId = "";
  selectedDeptID: Number;
  selectedAuthorId = "";
  selectedAuthorName = "";
  selectedAuthorExtId = "";
  selectedFormTypeName = "";
  selectedDepartmentName = "";
  formTypeValues: any;
  departmentValues = [];
  authorValues = [];
  showFormFields = false;
  formfieldsList = [];
  JobId = "";
  messages: string[] = [];
  maxdate: any;
  selectedDate: any;
  selectedOrderDate: any;
  hearingDate: any;
  orderDate: any;
  mode: string;
  interval: any;
  fileUpload = new FormControl();
  removable = true;
  FormName: string;
  organizationControl = new FormControl();
  organizationfilteredOptions: Observable<Organizations[]>;
  organizationOptions: any[];
  DepartmentDetails: any;
  FormFieldsGroup = new FormGroup({});
  selectedOrgExtId = "";
  uploadMediaDialog: MatDialogRef<UploadMediaComponent>;
  mediaDialogData: any;
  attachmentsDialogData: any;
  estimateDialogData: any;
  orderData: any;
  orderdetails: any;
  isEditMode = false;
  isshowEstimation: boolean = false;
  public ListOfAudioFiles: NgxFileDropEntry[] = [];
  ListOfAttachments: FileToUpload[] = [];
  ListOfAudioFiles1: FileToUpload[] = [];
  public originalFile: File;
  FileType = "";
  IsMergeAudios = false;
  totalEstimateAmount: number;
  numberOfMins: number;
  jobCostMinuteRateEstimation = "";
  receiptEmail: string;
  estimateJobTypeExtId = "";
  estimateJobTypeDisplayName = "";
  selectedIndex: number;
  public isDuplicate: boolean;
  fileCount: number;
  public ListOfNames: string;
  maxNumberOfFiles: number;
  exceedFileLimit: boolean;
  dialogRef: MatDialogRef<UploadAudioFileComponent>;
  requestorsOptions: any[];
  requestorfilteredOptions: Observable<dropdownmodel[]>;
  selectedRequestorId: Number;
  isRequestor: boolean = false;
  isJurisdiction: boolean = false;
  showRecordingTimes: boolean = false;
  selectedJurisdictionId: "";
  isCourtLocation: boolean = false;
  isCourtRoom: boolean = false;
  isOrderType: boolean = false;
  canUpload: boolean = false;
  selectedOrganization: Organizations;
  statusvalue: number;
  orderResponse: any = [];
  orderId: Number = null;
  ShowSaveButton: boolean = true;
  EditButtonText: string = "Save";
  orderStatusesOptions: any = [];
  notesDialogData: any;
  Notes = "";
  orderTypefilteredOptions!: Observable<dropdownmodel[]>;
  orderTypeList: dropdownmodel[] = [
    {
      id: '1',
      name: 'Daily',
      orderFormTypes: 'DAILY',
      formName: 'Daily Order'
    },
    {
      id: '2',
      name: 'Delayed',
      orderFormTypes: 'Delayed',
      formName: 'Delayed Order'
    }
  ];
  selectedJurisdiction: Jurisdictions;
  jurisdictionfilteredOptions: Observable<Jurisdictions[]>;
  jurisdictionOptions: any[];
  selectedCourtLocations: CourtLocations;
  courtLocationfilteredOptions: Observable<CourtLocations[]>;
  courtlocationsOptions: any[];
  selectedCourtRooms: CourtRooms;
  courtRoomfilteredOptions: Observable<CourtRooms[]>;
  courtRoomsOptions: any[];
  selectedjurisdicationExtId: string;
  selectedjurisdicationName: string;
  selectedcourtLocationExtId: string;
  selectedcourtLocationName: string;
  selectedcourtRoomExtId: string;
  selectedcourtRoomName: string;
  selectedorderTypeId: Number;
  orderDateMin: any = new Date();
  recordingTimes: { StartTime: string; EndTime: string }[] = [];
  timeListSource: any[] = [];
  selectedTimeIndex: number | null = null;
  isEditTimeMode = false;
  sendOrderToNSWCheck : boolean = false;

  @ViewChild('formTypeList', { static: false }) formTypeList: jqxDropDownListComponent;
  @ViewChild('departmentList', { static: false }) departmentList: jqxDropDownListComponent;
  @ViewChild('authorList', { static: false }) authorList: jqxDropDownListComponent;
  @ViewChild('msgNotification', { static: false }) msgNotification: jqxNotificationComponent;
  @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;
  @ViewChild('file', { static: false }) file;
  @ViewChild('myDateTimeInput', { static: false }) myDateTimeInput: jqxDateTimeInputComponent;
  @ViewChild('myOrderDateTimeInput', { static: false }) myOrderDateTimeInput: jqxDateTimeInputComponent;
  @ViewChild('startDateTime') startDateTime?: jqxDateTimeInputComponent;
  @ViewChild('endDateTime') endDateTime?: jqxDateTimeInputComponent;
  @ViewChild('timeList') timeList!: jqxListBoxComponent;
  constructor(
    private backendService: BackendService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private router: Router,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private fileacces: FileAccessService,
    private cdr: ChangeDetectorRef
  ) { }
  orderTypes = [
    { id: 1, name: 'Daily' },
    { id: 2, name: 'Delayed' }
  ];
  ngOnInit() {
    const roleName = localStorage.getItem('user_roleName');

    this.route.queryParams.subscribe(params => {
      this.title = params['title'] || 'Create Order';
      if (this.router.url === '/' || this.router.url === '/home') {
        this.title = 'Create Order';
        this.isEditMode = false;
      }
      // Optional: Load based on title or other param logic
      if (this.title == 'Update Order') {
        this.isEditMode = true;
        setTimeout(() => {
          this.loadEditOrder();
        }, 2000);
      }
    });
    this.route.queryParams.subscribe(params => {
      if (params['title']) {
        this.title = params['title'];
      }
    });
    var isUserlogin = this.backendService.CheckIsUserLoggedIn();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        Swal.close();
      }
    });
    if (isUserlogin) {
      this.spinner.show();
      this.loadgetorderstatuses();
      if (roleName != "Requestor") {
        this.isRequestor = true;
        this.loadOrganizations();
        this.departmentControl.disable({ onlySelf: true });
        this.jobtypeControl.disable({ onlySelf: true });
        this.formtypeControl.disable({ onlySelf: true });
        this.authorControl.disable({ onlySelf: true });
        this.requestorControl.disable({ onlySelf: true });
        this.courtRoomControl.disable({ onlySelf: true });
        this.spinner.hide();
      }
      else {
        this.loadDeparmentValues()
      }
      this.maxdate = new Date();
      this.clear();
      this.originalFile = null;
      this.ListOfNames = "";
      this.maxNumberOfFiles = 100;
      this.exceedFileLimit = false;
      var dateevent = new Date();
      this.organizationControl = new FormControl('');
      this.orderCreationForm = this.formBuilder.group({
        ishighPriority: new FormControl(false),
        language: new FormControl(''),
        caseNumber: new FormControl(null),
      });

      this.orderCreationForm.get('language')?.disable();
      this.orderCreationForm.get('caseNumber')?.disable();
    }
    this.orderTypefilteredOptions = this.orderTypeControl.valueChanges.pipe(
      startWith(''),
      map(value => this.filterOrderTypes(value))
    );
  }
  async loadEditOrder() {
    this.spinner.show();
    this.orderData = this.backendService.orderDetails;
    if (this.orderData == "") {
      this.goToOrderList();
    }

    if (!this.isEditMode) {
      this.markAsUnTouched(true);
    } else {

      this.orderdetails = this.orderData;
      if (this.orderData.id != undefined) {
        this.backendService.getOrderDetailsById(this.orderData.id).subscribe(
          response => {
            this.orderResponse = this.backendService.getJSONResponse(response).data;
            this.statusvalue = this.orderResponse.lastStatus.statusId;
            this.ShowSaveButton = (this.statusvalue != this.orderStatusesOptions.find(x => x.status === "Draft")?.statusId) ? false : true;
            this.orderId = this.orderResponse.orderId;
            this.departmentControl.enable({ onlySelf: true });
            this.jobtypeControl.enable({ onlySelf: true });
            this.formtypeControl.enable({ onlySelf: true });
            this.authorControl.enable({ onlySelf: true });
            this.requestorControl.enable({ onlySelf: true });
            this.orderCreationForm.get('language')?.enable();
            this.orderCreationForm.get('caseNumber')?.enable();
            this.loadOrganizationsforEditUser(this.orderResponse);
            this.orderCreationForm.setValue({
              ishighPriority: this.orderResponse.orderInfo.highPriority,
              language: this.orderResponse.orderInfo.language,
              caseNumber: this.orderResponse.caseNumber,
            });
          },
          (error) => {
            console.error('Error:', error);
            this.spinner.hide();
            return null;
          })
      }
    }
  }
  async loadOrganizationsforEditUser(res) {
    this.organizationOptions = [];
    const org_res = await this.loadOrganizationValues();
    let organizationList = this.backendService.getJSONResponse(org_res).data.customerList;
    for (let org of organizationList) {
      let data = {
        "id": org.id,
        "customerName": org.customerName + ' (' + org.tenantName + ')',
        "custExtId": org.custExtId,
        "directBucket": org.directBucket,
        "dbId": org.dbId,
        "ncurl": org.ncurl,
        "tenantId": org.tenantId,
        "tenantName": org.tenantName,
        "emailTemplateId": org.emailTemplateId,
        "sourceType": org.sourceType,
        "isFutureOrder": org.isFutureOrder,
      }
      this.organizationOptions.push(data);
    }
    let index;
    this.organizationOptions.forEach((val, i) => {
      if (val.custExtId == res.orderRecord.organizationExtId) {
        index = i;
        return;
      }
    });
    if (index >= 0) {
      this.organizationControl.setValue('');
      this.setOrganizationDetailsInEditMode(index, res);
    }
  }
  async setOrganizationDetailsInEditMode(index, res) {
    this.selectedOrganization = this.organizationOptions[index];
    if (this.selectedOrganization) {
      this.organizationControl.setValue(this.organizationOptions[index]);
      this.selectedOrgExtId = this.organizationOptions[index].custExtId;
      await this.loadDepartments(this.organizationOptions[index].custExtId, this.organizationOptions[index].tenantId);
      index = 0;
      this.departmentOptions.forEach((val, i) => {
        if (val.deptExtId == res.orderRecord.departmentExtId) {
          index = i;
          return;
        }
      });
      if (index >= 0) {
        this.departmentControl.setValue(this.departmentOptions[index]);
        this.selectedDepartmentId = this.departmentOptions[index].id;
        this.canUpload = (this.selectedDepartmentId == "" && this.selectedDeptExtId == "") ? false : true;
        this.selectedDepartmentId = this.departmentOptions[0].id;
        this.selectedDeptExtId = this.departmentOptions[index].deptExtId;
        this.selectedDeptID = this.departmentOptions[index].deptId;
        await this.loadAuthors(this.departmentOptions[index].id, this.departmentOptions[index].deptExtId);
        await this.loadJobTypeValues(this.departmentOptions[index].id);
        await this.loadFormTypeValues(this.departmentOptions[index].id);
        await this.loadrequestorsValues(this.departmentOptions[index].id);
        this.authorOptions.forEach((val, i) => {
          if (val.authorValue == res.orderRecord.authorExtId) {
            index = i;
            return;
          }
        });
        this.authorControl.setValue(this.authorOptions[index]);
        this.selectedAuthorExtId = this.authorOptions[index].authorValue;
        this.selectedAuthorName = this.authorOptions[index].authorKey;
        this.selectedAuthorId = this.authorOptions[index].id;
        index = 0;
        this.jobTypeOptions.forEach((val, i) => {
          if (val.name == res.orderRecord.jobTypeDisplayName) {
            index = i;
            return;
          }
        });
      }
      this.jobtypeControl.setValue(this.jobTypeOptions[index]);
      this.selectedJobTypeExtId = this.jobTypeOptions[index].externalid;
      this.selectedJobTypeDisplayName = this.jobTypeOptions[index].name;
      index = 0;
      this.formTypeOptions.forEach((val, i) => {
        if (val.id == res.orderRecord.orderFormId) {
          index = i;
          return;
        }
      });
      this.formtypeControl.setValue(this.formTypeOptions[index]);
      this.selectedFormTypeId = this.formTypeOptions[index].id;
      this.formTypeChangeEvent(this.selectedFormTypeId);

      index = 0;
      if (this.requestorsOptions != undefined) {
        this.requestorsOptions.forEach((val, i) => {
          if (res.orderRecord.orderRequesters.length != 0) {
            if (val.id == res.orderRecord.orderRequesters[0].userConfigs.id) {
              index = i;
              return;
            }
          }
          else {
            return;
          }
        });
      }
      this.requestorControl.setValue(this.requestorsOptions[index]);
      this.selectedRequestorId = this.requestorsOptions[index].id;
      index = 0;
      if (res.orderRecord.formData?.formFieldsData) {
        const parsedData = JSON.parse(res.orderRecord.formData.formFieldsData);
        if (!this.FormFieldsGroup) {
          this.FormFieldsGroup = new FormGroup({});
        }
        // Transform the flat object into an array of field definitions
        this.formfieldsList = Object.keys(parsedData).map(key => {
          return {
            propertyName: key,
            fieldType: 'textbox', // Default type — override if needed
            mandatory: false, // Default required — override if needed
            displayLabel: key, // Use key as label if none provided
            value: parsedData[key]
          };
        });
        // Now loop over the array to initialize form controls
        this.formfieldsList.forEach(field => {
          const key = field.propertyName;
          let value = field.value;
          // Type-specific conversion
          if (field.fieldType === 'checkbox') {
            value = !!value;
          } else if (field.fieldType === 'datepicker') {
            value = value ? new Date(value) : null;
          } else {
            value = value ?? '';
          }
          const validators = field.mandatory ? [Validators.required] : [];
          if (this.FormFieldsGroup.contains(key)) {
            this.FormFieldsGroup.get(key)?.setValue(value);
          } else {
            this.FormFieldsGroup.addControl(key, new FormControl(value, validators));
          }
        });
      }
    }
    this.spinner.hide();
  }
  private departmentfilter(name: any): dropdownmodel[] {
    const filterValue = name.toLowerCase();
    return this.departmentOptions.filter(option => option.name.toLowerCase().indexOf(filterValue) >= 0);
  }
  private jobTypefilter(name: any): dropdownmodel[] {
    const filterValue = name.toLowerCase();
    return this.jobTypeOptions.filter(option => option.name.toLowerCase().indexOf(filterValue) >= 0);
  }
  private formTypefilter(name: any): dropdownmodel[] {
    const filterValue = name.toLowerCase();
    return this.formTypeOptions.filter(option => option.formName.toLowerCase().indexOf(filterValue) >= 0);
  }
  private authorfilter(name: any): dropdownmodel[] {
    const filterValue = name.toLowerCase();
    return this.authorOptions.filter(option => option.name.toLowerCase().indexOf(filterValue) >= 0);
  }
  private requestorfilter(name: any): dropdownmodel[] {
    const filterValue = name.toLowerCase();
    return this.requestorsOptions.filter(option => option.name.toLowerCase().indexOf(filterValue) >= 0);
  }
  displayFn(dropdownmodel: dropdownmodel): string {
    return dropdownmodel && dropdownmodel.name ? dropdownmodel.name : '';
  }
  displayFnForOrganization(dropdownmodel: Organizations): string {
    return dropdownmodel && dropdownmodel.customerName ? dropdownmodel.customerName : '';
  }
  displayFnForFormTypes(dropdownmodel: dropdownmodel): string {
    return dropdownmodel && dropdownmodel.formName ? dropdownmodel.formName : '';
  }
  displayFnFororderType(dropdownmodel: dropdownmodel): string {
    return dropdownmodel && dropdownmodel.name ? dropdownmodel.name : '';
  }
  jobtypeValuesList = []
  async loadJobTypeValues(departmentId) {
    this.spinner.show();
    let jobTypeArray = [];
    this.jobtypeValuesList = [];
    var JobTypeDetails = await this.backendService.getDepartmentJobTypeValues(departmentId).toPromise();
    var jobtypeList = this.backendService.getJSONResponse(JobTypeDetails['data'].result);
    jobtypeList = jobtypeList.filter(item => item.externalId !== "Default");
    this.jobtypeValuesList = jobtypeList;
    for (let jobtype of jobtypeList) {
      let data = { 'id': jobtype.id, 'name': jobtype.displayName, 'externalid': jobtype.externalId, 'firstDraftEnabled': jobtype.firstDraftEnabled }
      jobTypeArray.push(data);
    }
    jobTypeArray.sort((a, b) => a.name.localeCompare(b.name));
    this.jobTypeOptions = jobTypeArray;
    this.jobTypefilteredOptions = this.jobtypeControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value['name']),
        map(name => name ? this.jobTypefilter(name) : this.jobTypeOptions.slice()),
      );
    if (this.jobTypeOptions.length == 1) {
      this.jobtypeControl.setValue(this.jobTypeOptions[0]);
      this.jobtypeControl.disable({ onlySelf: true });
      this.selectedJobTypeExtId = this.jobTypeOptions[0].externalid;
      this.selectedJobTypeDisplayName = this.jobTypeOptions[0].name;
    }
  }
  async loadrequestorsValues(departmentId) {
    this.spinner.show();
    let requestorArray = [];
    var requestorsDetails = await this.backendService.getrequestorsList(departmentId).toPromise();
    var requestorsList = this.backendService.getJSONResponse(requestorsDetails['data']);
    console.log('requestorsList : : ',requestorsList);
    if (requestorsList.length == 0) {
      this.sendNotification("No requestors from this department.", "error");
    }
    else {
      for (let requestors of requestorsList) {
        if(!requestors.status.includes(UserStatus.FORCE_CHANGE_PASSWORD))
        {
        let data = { 'id': requestors.id, 'name': requestors.userName }
        requestorArray.push(data);
        }
      }
      console.log("requestorArray",requestorArray)
      if(requestorArray.length == 0)
      {
        this.sendNotification("No requestors from this department.", "error");
        return;
      }
      requestorArray.sort((a, b) => a.name.localeCompare(b.name));
      this.requestorsOptions = requestorArray;
      this.requestorfilteredOptions = this.requestorControl.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value['name']),
          map(name => name ? this.requestorfilter(name) : this.requestorsOptions.slice()),
        );
      if (this.requestorsOptions.length == 1) {
        this.requestorControl.setValue(this.requestorsOptions[0]);
        this.requestorControl.disable({ onlySelf: true });
        this.selectedRequestorId = this.requestorsOptions[0].id;
      }
    }
  }
  async loadFormTypeValues(departmentId) {
    this.spinner.show();
    const depts = await firstValueFrom(this.deptfilteredOptions);
    const selectedDepartment = depts.find(dept => dept.id === departmentId);
    if (selectedDepartment.orderFormTypes != null) {
      this.formTypeOptions = JSON.parse(selectedDepartment.orderFormTypes);
      this.formTypefilteredOptions = this.formtypeControl.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value['formName']),
          map(formName => formName ? this.formTypefilter(formName) : this.formTypeOptions.slice()),
        );
      if (this.formTypeOptions.length == 1) {
        this.formtypeControl.setValue(this.formTypeOptions[0]);
        this.formtypeControl.disable({ onlySelf: true });
        this.selectedFormTypeId = this.formTypeOptions[0].id;
        this.formTypeChangeEvent(this.selectedFormTypeId);
      }
    } else {
      this.sendNotification("No form types from this department.", "error");
    }
  }
  goToOrderList() {
    const route = '/admin/orders';
    this.router.navigate([route]); // Correct way to navigate
  }

  departmentSingleOptionChangeEvent(event: any): void {
    if (event.id) {
      this.selectedDepartmentId = event.id;
      this.selectedDeptExtId = event.deptExtId;
      this.selectedDeptID = event.deptId;
      this.formtypeControl.setValue('');
      this.authorControl.setValue('');
      this.requestorControl.setValue('');
      this.loadAuthors(event.id, event.deptExtId);
      this.loadJobTypeValues(event.id);
      this.loadFormTypeValues(event.id);
      this.loadrequestorsValues(event.id);
      this.isshowEstimation = (this.sendOrderToNSWCheck) ? false : ((this.selectedDepartmentId == "" && this.selectedDeptExtId == "") ? false : true);
      this.canUpload = true;
      if (this.sendOrderToNSWCheck) {
        this.isJurisdiction = this.sendOrderToNSWCheck;
        this.isCourtLocation = this.sendOrderToNSWCheck;
        this.isCourtRoom = this.sendOrderToNSWCheck;
        this.isOrderType = this.sendOrderToNSWCheck;
        this.showRecordingTimes = this.sendOrderToNSWCheck;
        const today = new Date();
        today.setHours(0, 0, 0, 0);   // remove time
        this.orderDateMin = today;
        this.loadJurisdictions(this.selectedOrgExtId);
        this.loadCourtLocations(this.selectedOrgExtId);
        asyncScheduler.schedule(() => {
          this.setTimes();
        })
      }
      localStorage.setItem('departments', event.id);
      this.jobtypeControl.enable({ onlySelf: true });
      this.formtypeControl.enable({ onlySelf: true });
      this.authorControl.enable({ onlySelf: true });
      this.requestorControl.enable({ onlySelf: true });
      this.orderCreationForm.get('language')?.enable();
      this.orderCreationForm.get('caseNumber')?.enable();
    }
  };
  authorValuesList = []
  async loadAuthors(customerId, deptExtId) {
    this.spinner.show();
    let authorArray = [];
    this.authorValuesList = [];
    let AuthorDetails;
    await this.backendService.getAuthors(customerId, deptExtId).subscribe(
      res => {
        let NCauthorListList = this.backendService.getJSONResponse(res['data'].authorList);
        if (NCauthorListList != null) {
          if (NCauthorListList.length != 0) {
            const authorList = NCauthorListList;
            this.authorValuesList = authorList;
            for (let author of authorList) {
              let data = { 'id': author.id, 'name': author.authorKey + ' (' + author.authorValue + ')' }
              authorArray.push(data);
            }
            this.authorOptions = authorArray;
            this.authorfilteredOptions = this.authorControl.valueChanges
              .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value['name']),
                map(name => name ? this.authorfilter(name) : this.authorOptions.slice()),
              );
            if (this.authorOptions.length == 1) {
              this.authorControl.setValue(this.authorOptions[0]);
              this.selectedAuthorId = this.authorOptions[0].id;
              this.selectedAuthorName = "";
              this.selectedAuthorExtId = "";
            }
          }
        }
        let NetScribeauthorList = this.backendService.getJSONResponse(res['data'].nsAuthorList);
        if (NetScribeauthorList != null) {
          if (NetScribeauthorList.length != 0) {
            const authorList = NetScribeauthorList;
            this.authorValuesList = authorList;
            for (let author of authorList) {
              let data = { 'id': author.customerId, 'name': author.authorKey + ' (' + author.authorValue + ')', 'authorKey': author.authorKey, 'authorValue': author.authorValue }
              authorArray.push(data);
            }
            authorArray.sort((a, b) => a.name.localeCompare(b.name));
            this.authorOptions = authorArray;
            this.authorfilteredOptions = this.authorControl.valueChanges
              .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value['name']),
                map(name => name ? this.authorfilter(name) : this.authorOptions.slice()),
              );
            if (this.authorOptions.length == 1) {

              this.authorControl.setValue(this.authorOptions[0]);
              this.authorControl.disable({ onlySelf: true });
              this.selectedAuthorId = "";
              this.selectedAuthorName = this.authorOptions[0].authorKey;
              this.selectedAuthorExtId = this.authorOptions[0].authorValue;
            }
          }
          else {
            this.sendNotification('Unable to get Authors From NetScribe, Please check in NetScribe.', 'error');
          }
        }
      },
      err => {
        const er = this.backendService.getJSONResponse(err);
        this.sendNotification('Unable to get Authors From NetScribe, Please check in NetScribe.', 'error');
        this.backendService.AWSLog("error", "Problem occurred while getting author list.: " + err).subscribe();
        this.spinner.hide();
      }
    );
  };
  loadAuthorValues(customerId) {
    let authorArray = [];
    this.authorValuesList = [];
    this.backendService.getAuthors(customerId, null).subscribe(
      res => {
        const authorList = this.backendService.getJSONResponse(res).data.authorList;
        this.authorValuesList = authorList;
        for (let author of authorList) {
          let data = { 'id': author.id, 'name': author.authorKey + ' (' + author.authorValue + ')' }
          authorArray.push(data);
        }
        this.authorOptions = authorArray;
        this.authorfilteredOptions = this.authorControl.valueChanges
          .pipe(
            startWith(''),
            map(value => typeof value === 'string' ? value : value['name']),
            map(name => name ? this.authorfilter(name) : this.authorOptions.slice()),
          );
        if (this.authorOptions.length == 1) {
          this.authorControl.setValue(this.authorOptions[0]);
          this.selectedAuthorId = this.authorOptions[0].id;
          this.selectedAuthorName = this.authorOptions[0].authorKey;
          this.selectedAuthorExtId = this.authorOptions[0].authorValue;
        }
      }
    );
  }
  async loadFormTypeDetails(formTypeId) {
    this.showFormFields = false;
    this.selectedFormTypeId = formTypeId;
    this.backendService.getorderformfields(formTypeId).subscribe(response => {
      let fieldsListresponse;
      fieldsListresponse = this.backendService.getJSONResponse(response); // Ensure this function returns the expected JSON
      this.formfieldsList = fieldsListresponse.data.formFields;
      this.formfieldsList = this.formfieldsList.sort((a, b) => a.propertyName.localeCompare(b.propertyName));
      this.formfieldsList.forEach(formfield => {
        this.FormFieldsGroup.addControl(formfield.propertyName, new FormControl());
        if (formfield.parentField) {
          const parentControl = this.FormFieldsGroup.get(formfield.parentField);
          formfield.visible = this.shouldShow(formfield, parentControl?.value);
          parentControl?.valueChanges.subscribe(val => {
            this.updateVisibility(formfield, val);
          });
        } else {
          formfield.visible = true; // ✅ This shows the field on initial load
        }

        if (formfield.fieldType == 'dropdown') {
          formfield.options = JSON.parse(formfield.options)
        }
      });
    });
    this.showFormFields = true;
  }
  updateVisibility(field: any, parentValue: any) {
    this.FormFieldsGroup.get(field.propertyName)?.reset();
    field.visible = this.shouldShow(field, parentValue);
  }

  shouldShow(field: any, parentValue: any): boolean {
    let pval = parentValue == null ? parentValue : parentValue.toString();
    return field.parentValue.toLowerCase() === pval;
  }
  sendNotification(message, messageType) {
    this.msgNotification.elementRef.nativeElement.querySelector('.jqx-notification-content').innerHTML = message;
    this.msgNotification.template(messageType);
    this.msgNotification.open();
  }
  jobTypeChangeEvent(event: any): void {
    if (event) {
      this.selectedJobTypeExtId = event.externalid;
      this.selectedJobTypeDisplayName = event.name;
    }
  };
  formTypeChangeEvent(id: any): void {
    if (id) {
      this.spinner.show();
      this.selectedFormTypeId = id;
      this.FormFieldsGroup = new FormGroup({});
      this.formfieldsList = [];
      this.loadFormTypeDetails(this.selectedFormTypeId);
      this.spinner.hide();
    }
  };
  departmentChangeEvent(event: any): void {
    if (event.option.value.id) {
      this.spinner.show();
      this.selectedDepartmentId = event.option.value.id;
      this.selectedDeptExtId = event.option.value.deptExtId;
      this.selectedDeptID = event.option.value.deptId;
      this.loadAuthors(event.option.value.id, event.option.value.deptExtId);
      this.loadJobTypeValues(event.option.value.id);
      this.loadFormTypeValues(event.option.value.id);
      this.loadrequestorsValues(event.option.value.id);
      this.departmentOptions[0] = event.option.value;
      this.isshowEstimation = (this.sendOrderToNSWCheck) ? false : ((this.selectedDepartmentId == "" && this.selectedDeptExtId == "") ? false : true);
      localStorage.setItem('departments', event.option.value.id);
      this.canUpload = (this.selectedDepartmentId == "" && this.selectedDeptExtId == "") ? false : true;
      this.jobtypeControl.setValue('');
      this.formtypeControl.setValue('');
      this.authorControl.setValue('');
      this.requestorControl.setValue('');
      this.orderCreationForm.get('language')?.setValue('');
      this.orderCreationForm.get('caseNumber')?.setValue('');
      this.jobtypeControl.enable({ onlySelf: true });
      this.formtypeControl.enable({ onlySelf: true });
      this.authorControl.enable({ onlySelf: true });
      this.requestorControl.enable({ onlySelf: true });
      this.orderCreationForm.get('language')?.enable();
      this.orderCreationForm.get('caseNumber')?.enable();
      this.spinner.hide();
    }
  };
  loadAuthorValuesByDeptExtId(deptExtId) {
    let authorArray = [];
    this.authorValuesList = [];
    this.backendService.getAuthorsByDeptExtId(deptExtId).subscribe(
      res => {
        const authorList = this.backendService.getJSONResponse(res).data.nsAuthorList;
        this.authorValuesList = authorList;
        for (let author of authorList) {
          let data = { 'id': author.customerId, 'name': author.authorKey + ' (' + author.authorValue + ')', 'authorKey': author.authorKey, 'authorValue': author.authorValue }
          authorArray.push(data);
        }
        this.authorOptions = authorArray;
        this.authorfilteredOptions = this.authorControl.valueChanges
          .pipe(
            startWith(''),
            map(value => typeof value === 'string' ? value : value['name']),
            map(name => name ? this.authorfilter(name) : this.authorOptions.slice()),
          );
        if (this.authorOptions.length == 1) {

          this.authorControl.setValue(this.authorOptions[0]);
          this.selectedAuthorId = "";
          this.selectedAuthorName = this.authorOptions[0].authorKey;
          this.selectedAuthorExtId = this.authorOptions[0].authorValue;
        }
      },
      err => {
        const er = this.backendService.getJSONResponse(err);
        this.sendNotification('Problem occurred while checking author list. ' + JSON.stringify(er), 'error');
        this.backendService.AWSLog("error", "Problem occurred while checking author list.: " + err).subscribe();
        this.spinner.hide();
      }
    );
  }
  clearDropdownSelection() {
    this.selectedDepartmentId = '';
    this.selectedDeptExtId = '';
    this.selectedDeptID = null;
    this.selectedFormTypeId = null;
    this.selectedAuthorId = '';
    this.selectedAuthorExtId = '';
    this.selectedAuthorName = '';
    this.selectedOrgExtId = '';
  }
  clearDropdownValues() {
    return of([])
  }
  departmentChange() {
    this.selectedDepartmentId = '';
    this.selectedDeptExtId = '';
    this.selectedDeptID = null;
    this.selectedFormTypeId = null;
    this.selectedAuthorId = '';
    this.selectedAuthorName = '';
    this.selectedAuthorExtId = '';
    this.selectedJobTypeExtId = '';
    this.selectedJobTypeDisplayName = '';
    this.showFormFields = false;
    this.selectedRequestorId = null;
    this.jobTypefilteredOptions = this.clearDropdownValues();
    this.formTypefilteredOptions = this.clearDropdownValues();
    this.authorfilteredOptions = this.clearDropdownValues();
    this.requestorfilteredOptions = this.clearDropdownValues();
    this.orderCreationForm.get('language')?.setValue('');
    this.orderCreationForm.get('caseNumber')?.setValue('');
    this.isshowEstimation = (this.sendOrderToNSWCheck) ? false : ((this.selectedDepartmentId == "" && this.selectedDeptExtId == "") ? false : true);
    this.canUpload = (this.selectedDepartmentId == "" && this.selectedDeptExtId == "") ? false : true;
  }
  jobtypeChange() {
    this.selectedJobTypeExtId = '';
    this.selectedJobTypeDisplayName = '';
    this.jobtypeControl.setValue('');
  }
  formtypeChange() {
    this.selectedFormTypeId = null;
    this.showFormFields = false;
    this.formtypeControl.setValue('');
  }
  authorChange() {
    this.selectedAuthorId = '';
    this.selectedAuthorExtId = '';
    this.selectedAuthorName = '';
  }
  authorChangeEvent(event: any): void {
    if (event) {
      this.selectedAuthorName = event.authorKey;
      this.selectedAuthorExtId = event.authorValue;
      this.selectedAuthorId = event.id;
    }
  };
  requestorChange() {
    this.selectedRequestorId = null;
  }
  requestorChangeEvent(event: any): void {
    if (event) {
      this.selectedRequestorId = event.id;
    }
  };
  jurisdicationChange() {
    this.selectedjurisdicationExtId = null;
  }
  jurisdicationChangeEvent(event: any): void {
    if (event) {
      this.selectedjurisdicationExtId = event.externalId;
      this.selectedjurisdicationName = event.name;
    }
  };
  courtLocationChange() {
    this.selectedcourtLocationExtId = null;
    this.courtRoomControl.setValue('');
    this.courtRoomfilteredOptions = this.clearDropdownValues();
  }
  courtLocationChangeEvent(event: any): void {
    if (event) {
      this.selectedcourtLocationExtId = event.externalId;
      this.selectedcourtLocationName = event.name;
    }
    this.loadCourtRooms(event.id);
    this.courtRoomControl.enable({ onlySelf: true });
  };
  courtRoomChange() {
    this.selectedcourtRoomExtId = null;
  }
  courtRoomChangeEvent(event: any): void {
    if (event) {
      this.selectedcourtRoomExtId = event.externalId;
      this.selectedcourtRoomName = event.name;
    }
  };
  //orderTypeChange
  orderTypeChange() {
    this.selectedorderTypeId = null;
  }
  orderTypeChangeEvent(event: any): void {
    if (event) {
      this.selectedorderTypeId = event.id;
    }
  };
  isValidFormFieldsGroup(controlName, error) {
    return this.FormFieldsGroup.controls[controlName] && this.FormFieldsGroup.controls[controlName].hasError(error);
  }
  isValid(controlName, error) {
    return this.orderCreationForm && this.orderCreationForm.controls[controlName].hasError(error);
  }
  markAsTouched(value: boolean) {
    Object.keys(this.FormFieldsGroup.controls).forEach(field => {
      const control = this.FormFieldsGroup.get(field);
      if (control instanceof FormControl) {
        if (this.isValidFormFieldsGroup(field, 'required')) {
          this.FormFieldsGroup.controls[field].markAsTouched({ onlySelf: value });
        }
      }
    });
  }
  markAsUnTouched(value: boolean) {
    Object.keys(this.FormFieldsGroup.controls).forEach(field => {
      const control = this.FormFieldsGroup.get(field);
      if (control instanceof FormControl) {
        if (this.isValidFormFieldsGroup(field, 'required')) {
          this.FormFieldsGroup.controls[field].markAsUntouched({ onlySelf: value });
        }
      }
    });
  }
  clearInputData() {
    Object.keys(this.FormFieldsGroup.controls).forEach(field => {
      var fielddetails = this.formfieldsList.filter(x => x.propertyName == field);
      if (fielddetails[0].defaultValue == null || fielddetails[0].defaultValue == "") {
        const control = this.FormFieldsGroup.get(field);
        if (control instanceof FormControl) {
          this.FormFieldsGroup.controls[field].setValue('');
        }
      }
    });
    this.FormFieldsGroup.reset();
  }
  clearJobDataSelection() {
    this.mode = "clear";
    this.sweetalert();
  }
  sweetalert() {
    var reqsubstring = "";
    if (this.mode == "clear") {
      reqsubstring = "Are you sure, you want to clear the selected data? All the selected and/or recorded files will be deleted.";
    }
    Swal.fire({
      text: reqsubstring,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      cancelButtonText: `No`,
      denyButtonText: `Cancel`,
      confirmButtonColor: '#187EB1',
      cancelButtonColor: '#5b5b5b',
    }).then((result) => {
      if (result.value) {
        if (this.mode == "clear") {
          this.clear();
        }
      }
    })
  }
  clear() {
    this.remove();
    this.removeJobAttachments();
    this.clearInputData();
    this.markAsUnTouched(true);
  }
  cancel() {
    this.goToOrderList();
  }
  remove() {
    this.hearingDate = null;
    this.ListOfAudioFiles = [];
    this.ListOfAudioFiles1 = [];
    ListOfOriginalFiles = [];
    this.originalFile = null;
    ListzipFiles = [];
    ListOfMergeAudioFiles = [];
    MergeAudioFileNameList = [];
    ListOfAttachmentFiles = [];
    this.receiptEmail = "";
    this.numberOfMins = null;
    this.totalEstimateAmount = null;
    ListOfZipFiles = [];
    this.ListOfNames = "";
    this.file = null;
    this.hearingDate = new Date();
    this.orderId = null;
    this.statusvalue = null;
    this.Notes = "";
  }
  clearDropDownData() {
    this.formTypeList.uncheckAll();
    this.departmentList.uncheckAll();
    this.authorList.uncheckAll();
    this.selectedAuthorId = '';
    this.selectedAuthorName = '';
    this.selectedAuthorExtId = '';
    this.selectedDepartmentId = '';
    this.selectedDeptExtId = '';
    this.selectedDeptID = null;
    this.selectedFormTypeId = null;
  }
  validationBeforeSubmit() {
    let message = '';
    let result = true;
    if (this.selectedOrgExtId.trim() == '' && this.isRequestor) {
      message = 'Please select organization.';
      result = false;
    }
    else if (this.selectedDepartmentId.trim() == '') {
      message = 'Please select a Department.';
      result = false;
    }
    else if (this.selectedJobTypeExtId == null) {
      message = 'Selected Job Type does not have External Id.';
      result = false;
    }
    else if (this.selectedJobTypeExtId.trim() == '') {
      message = 'Please select a Job Type.';
      result = false;
    }
    else if (this.selectedFormTypeId == null) {
      message = 'Please select a Form Type.';
      result = false;
    }
    else if (this.selectedAuthorExtId.trim() == '') {
      message = 'Please select a Author.';
      result = false;
    }
    else if (this.selectedRequestorId == null && this.isRequestor) {
      message = 'Please select requestor.';
      result = false;
    }
    else if (this.sendOrderToNSWCheck) {
      if (this.selectedjurisdicationExtId == null) {
        message = 'Please select Jurisdiction.';
        result = false;
      }
      else if (this.selectedcourtLocationExtId == null) {
        message = 'Please select CourtLocation.';
        result = false;
      }
      else if (this.selectedcourtRoomExtId == null) {
        message = 'Please select CourtRoom.';
        result = false;
      }
      else if (this.selectedorderTypeId == null) {
        message = 'Please select OrderType.';
        result = false;
      }
      else if (this.recordingTimes.length == 0) {
        message = 'Please select RecordingTimes.';
        result = false;
      }
    }
    else if ((this.orderCreationForm.controls.caseNumber.value == "" || this.orderCreationForm.controls.caseNumber.value == null) && !this.orderCreationForm.controls.caseNumber.valid) {
      message = 'Please enter Case Number.';
      result = false;
    }
    else if (this.authorValuesList.length > 0) {
      if (environment.region == "ap-southeast-2") {
        //Production-Australia Environment
        if (this.selectedAuthorExtId.trim() == '') {
          message = 'Please select an Author';
          result = false;
        }
      }
      else {
        if (this.selectedAuthorId.trim() == '' && this.selectedAuthorExtId.trim() == '') {
          message = 'Please select an Author';
          result = false;
        }
      }
    }

    if (!result)
      this.sendNotification(message, 'error');
    return result;
  }
  convertStartDatetoUnix(date) {
    var reqdate = this.datePipe.transform(date, 'yyyy-MM-dd');
    //current time
    var currenttime = new Date();
    var time = this.datePipe.transform(currenttime, 'HH:mm:ss');
    //Combine both date and time
    var datetime = reqdate + "T" + time;
    let newDate = new Date(datetime);
    var reqstartDate = this.datePipe.transform(newDate, 'yyyy-MM-dd HH:mm:ss');
    var StringtoDate = new Date(reqstartDate);
    this.selectedDate = (StringtoDate.getTime() / 1000);
    this.selectedDate = this.selectedDate + 1;
  }
  async createOrder(actionType: string) {
    this.spinner.show();
    if(this.sendOrderToNSWCheck){
    var date = this.myDateTimeInput.val();
    var orderdate = this.myOrderDateTimeInput.val();
    var hearingDate = this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
    this.hearingDate = hearingDate;
    var orderDate = this.datePipe.transform(orderdate, 'yyyy-MM-dd HH:mm:ss');
    this.orderDate = orderDate;
    }
    if (this.orderCreationForm.invalid) {
      this.orderCreationForm.markAllAsTouched();
    }
    this.markAsTouched(true);
    if (this.validationBeforeSubmit() && this.FormFieldsGroup.valid && this.orderCreationForm.valid) {
      const ordercreatemodel = this.createorderModel();
      ordercreatemodel.attachmentFiles = this.ListOfAttachments;
      ordercreatemodel.audioFiles = this.ListOfAudioFiles1;
      ordercreatemodel.numberofMinutesforEstimation = this.numberOfMins;
      ordercreatemodel.totalEstimationCost = this.totalEstimateAmount;
      ordercreatemodel.perMinuteEstimationRate = this.jobCostMinuteRateEstimation;
      ordercreatemodel.RequestorId = this.selectedRequestorId = (!this.isRequestor) ? Number(localStorage.getItem('id')) : this.selectedRequestorId;
      const draftStatusId = this.orderStatusesOptions.find(x => x.status === "Draft")?.statusId;
      const orderedStatusId = this.orderStatusesOptions.find(x => x.status === "Ordered")?.statusId;
      ordercreatemodel.statusId = (actionType === "Submit") ? ((this.statusvalue == null || this.statusvalue === draftStatusId) ? orderedStatusId : this.statusvalue) : draftStatusId;
      ordercreatemodel.previousStatusId = (actionType === "Submit") ? (this.statusvalue == null ? orderedStatusId : this.statusvalue) : draftStatusId;
      // ordercreatemodel.statusId = (actionType == "Submit") ? ((this.statusvalue == null || this.statusvalue == this.orderStatusesOptions.filter(x=>x.status == "Draft").statusId) ? this.orderStatusesOptions.filter(x=>x.status == "Ordered").statusId : this.statusvalue) : this.orderStatusesOptions.filter(x=>x.status == "Draft").statusId;
      // ordercreatemodel.previousStatusId = (actionType == "Submit") ? ((this.statusvalue == null) ? this.orderStatusesOptions.filter(x=>x.status == "Ordered").statusId : this.statusvalue) : this.orderStatusesOptions.filter(x=>x.status == "Draft").statusId;
      this.orderId = (this.orderResponse.orderId == null) ? 0 : this.orderId;
      console.log('create order : :', ordercreatemodel)
      this.backendService.OrderCreate(ordercreatemodel, this.orderId).subscribe(
        res => {
          const result = this.backendService.getJSONResponse(res);
          if (result.data.message == "Order updated successfully.") {
            (actionType === "Submit") ? this.sendNotification("Submission successful. Your order has been Updated.", "success") : this.sendNotification("Draft Updated. You can submit it when ready.", "success");
            this.orderId = null;
            this.statusvalue = null;
            this.sendOrderToNSWCheck && this.clearCourtOrderFields(); // If sendOrderToNSWCheck is true, clear the order details
            this.clearInputData();
            this.goToOrderList();
            this.spinner.hide();
          }
          else if (result.data.multipleAudioFilesUrl.length == 0 && result.data.orderAttachmentUrl.length == 0 && result.data.orderId != null) {
            (actionType === "Submit") ? this.sendNotification("Submission successful. Your order has been created.", "success") : this.sendNotification("Draft saved. You can submit it when ready.", "success");
            this.sendOrderToNSWCheck && this.clearCourtOrderFields(); // If sendOrderToNSWCheck is true, clear the order details
            this.clearInputData();
            this.orderId = null;
            this.statusvalue = null;
            this.Notes = "";
            this.spinner.hide();
          }
          else {
            if (this.ListOfAttachments.length > 0) {
              this.uploadAttachments(result.data.orderAttachmentUrl);
            }
            if (this.ListOfAudioFiles1.length > 0) {
              this.uploadMergeAudioFiles(result.data.multipleAudioFilesUrl, result.data.orderAttachmentUrl);
            }
            (actionType === "Submit") ? this.sendNotification("Submission successful. Your order has been created.", "success") : this.sendNotification("Draft saved. You can submit it when ready.", "success");
            this.sendOrderToNSWCheck && this.clearCourtOrderFields(); // If sendOrderToNSWCheck is true, clear the order details
            this.clearInputData();
            this.clear();
          }
        },
        err => {
          const er = this.backendService.getJSONResponse(err);
          this.backendService.AWSLog("error", "Problem occurred while submitting the job with filename: Merge file Actual Error : " + err).subscribe();
          this.spinner.hide();
        }
      );
    }
    else {
      localStorage.removeItem('spinnerStatus');
      localStorage.setItem('spinnerStatus', "false");
      this.spinner.hide();
    }
  }
  async uploadAttachmentOnlyToBucket(filedetails, attachmenturl) {
    this.progress = 0;
    const fileObject = {
      name: filedetails.name,
      size: (filedetails.size / (1024 * 1024)).toFixed(2) + ' MB',
      progress: 0,
      path: null
    };

    (await this.fileacces.uploadWithProgress(attachmenturl, filedetails)).subscribe({
      next: (event: any) => {
        this.spinner.show();
        if (event.type === 'progress') {
          this.progress = event.value;
        } else if (event.type === 'response') {
          CompleteAttachmentscount = CompleteAttachmentscount + 1;
          this.progress = null;
          if (Attachmentscount1 == CompleteAttachmentscount) {
            if (Attachmentscount1 == 1) {
              Swal.fire(Attachmentscount1 + ' - Attachment Uploaded successfully.', '', 'success');
            }
            else {
              Swal.fire(Attachmentscount1 + ' - Attachments Uploaded successfully.', '', 'success');
            }
            CompleteAttachmentscount = 0;
            Attachmentscount1 = 0;
            this.spinner.hide();
          }
        }
      },
      error: (err) => {
        console.log(err);
        this.progress = null;
        Swal.fire('Attachment file upload failed.', '', 'error');
        this.backendService.AWSLog("error", this.JobId + "Error - uploadAttachmentOnlyToBucket Method :::  " + JSON.stringify(err)).subscribe();
        this.removeFileByName(filedetails.name);
        this.spinner.hide();
      }
    });
  }

  async uploadAttachmentToBucket(filedetails, attachmenturl, filepath, NCJobId, jobAttachmentUrl) {
    this.progress = 0;
    const fileObject = {
      name: filedetails.name,
      size: (filedetails.size / (1024 * 1024)).toFixed(2) + ' MB',
      progress: 0,
      path: null
    };
    (await this.fileacces.uploadWithProgress(attachmenturl, filedetails)).subscribe({
      next: (event: any) => {
        if (event.type === 'progress') {
          this.progress = event.value;
        } else if (event.type === 'response') {
          CompleteAudioFilescount = CompleteAudioFilescount + 1;
          this.progress = null;
          if (MergeAudioFilescount == CompleteAudioFilescount && NCJobId != null) {
            if (MergeAudioFilescount == 1) {
              Swal.fire(MergeAudioFilescount + ' - File submitted successfully.', '', 'success');
            } else {
              Swal.fire(MergeAudioFilescount + ' - Files submitted successfully.', '', 'success');
            }
            MergeAudioFilescount = 0;
            CompleteAudioFilescount = 0;
            this.spinner.hide();
          }
        }
      },
      error: (err) => {
        console.log(err);
        this.progress = null;
        this.sendNotification('Audio file upload failed.', 'error');
        this.spinner.hide();
      }
    });

  }
  async MergeAudioFileProcess(jobId, bucketPath, filenames, jobAttachmentUrl) {
    this.backendService.MergeAudioFilesToNSW(jobId, bucketPath, filenames).subscribe(
      res => {
        this.spinner.hide();
      },
      err => {
        const er = this.backendService.getJSONResponse(err);
      }
    );
  }
  async uploadMergeAudioFiles(jobMergeAudioFilesUrl, jobAttachmentUrl) {
    this.spinner.show();
    let listofAttachmentsUrls = [];
    var splitted;
    listofAttachmentsUrls = jobMergeAudioFilesUrl;
    var counter = 0;
    var filepath;
    listofAttachmentsUrls.forEach(async attachmenturl => {
      counter = counter + 1;
      splitted = attachmenturl.split("/", 7);
      var AttachmentFileName = splitted[5];
      AttachmentFileName = AttachmentFileName.substring(0, AttachmentFileName.indexOf("?"));
      ListOfMergeAudioFiles.forEach(async AudioFile => {
        if (AttachmentFileName == AudioFile.FileName) {
          MergeAudioFilescount = MergeAudioFilescount + 1;
          filepath = splitted[3] + "/" + splitted[4];
          await this.uploadAttachmentToBucket(AudioFile, attachmenturl, filepath, splitted[4], jobAttachmentUrl);
        }
      });
    });
  };
  async uploadAttachments(jobAttachmentUrl) {
    let listofAttachmentsUrls = [];
    var Attachmentscount = 0;
    var splitted;
    listofAttachmentsUrls = jobAttachmentUrl;
    listofAttachmentsUrls.forEach(attachmenturl => {
      splitted = attachmenturl.split("/", 7);
      var AttachmentFileName = splitted[5];
      AttachmentFileName = AttachmentFileName.substring(0, AttachmentFileName.indexOf("?"));
      ListOfAttachmentFiles.forEach(attachment => {
        if (AttachmentFileName == attachment.filename) {
          Attachmentscount = Attachmentscount + 1;
          Attachmentscount1 = Attachmentscount;
          this.uploadAttachmentOnlyToBucket(attachment, attachmenturl);
        }
      });
    });
    this.spinner.hide();
  };
  createorderModel() {
    let id = localStorage.getItem('id')
    const ordercreatemodel = new OrderInputDto();
    ordercreatemodel.deptId = this.selectedDeptID;
    ordercreatemodel.organizationExtId = this.selectedOrgExtId;
    ordercreatemodel.departmentExtId = this.selectedDeptExtId;
    ordercreatemodel.jobTypeExtId = this.selectedJobTypeExtId;
    ordercreatemodel.authorExtId = this.selectedAuthorExtId;
    ordercreatemodel.caseNumber = this.orderCreationForm.controls.caseNumber.value ? this.orderCreationForm.controls.caseNumber.value : "";
    ordercreatemodel.hearingDate = this.hearingDate;
    ordercreatemodel.language = this.orderCreationForm.controls.language.value ? this.orderCreationForm.controls.language.value : "";
    ordercreatemodel.highPriority = this.orderCreationForm.controls.ishighPriority.value ? this.orderCreationForm.controls.ishighPriority.value : false;
    ordercreatemodel.orderFormId = this.selectedFormTypeId;
    ordercreatemodel.CreatedBy = Number(id);
    ordercreatemodel.formData = {
      FormFieldsData: JSON.stringify(this.FormFieldsGroup.value)
    };;
    ordercreatemodel.authorName = this.selectedAuthorName;
    ordercreatemodel.jobTypeDisplayName = this.selectedJobTypeDisplayName;
    ordercreatemodel.Notes = this.Notes == "" ? null : JSON.stringify([{ id: 1, userName: localStorage.getItem('userName'), message: this.Notes, createdAt: new Date() }]);
    if (this.sendOrderToNSWCheck) {
      ordercreatemodel.jurisdictionName = this.selectedjurisdicationName;
      ordercreatemodel.jurisdictionExtId = this.selectedjurisdicationExtId;
      ordercreatemodel.courtLocationName = this.selectedcourtLocationName;
      ordercreatemodel.courtLocationExtId = this.selectedcourtLocationExtId;
      ordercreatemodel.courtRoomName = this.selectedcourtRoomName;
      ordercreatemodel.courtRoomExtId = this.selectedcourtRoomExtId;
      ordercreatemodel.orderType = this.selectedorderTypeId;
      ordercreatemodel.orderDate = this.orderDate;
      this.recordingTimes.sort((a, b) =>
        this.timeToMinutes(a.StartTime) - this.timeToMinutes(b.StartTime)
      );
      ordercreatemodel.recordingTimes = JSON.stringify(this.recordingTimes);
    }
    return ordercreatemodel;
  }
  onValueChanged(event: any): void {
    var selecteddate = event.args.date;
    this.hearingDate = this.datePipe.transform(selecteddate, 'yyyy-MM-dd HH:mm:ss');
  }
  onOrderDateValueChanged(event: any): void {
    var selecteddate = event.args.date;
    this.orderDate = this.datePipe.transform(selecteddate, 'yyyy-MM-dd HH:mm:ss');
  }
  onProgressUpdate(newProgress) {
    this.progress = newProgress.progress;
  }
  organizationChange() {
    this.departmentControl.setValue('');
    this.selectedOrgExtId = '';
    this.selectedDepartmentId = '';
    this.selectedDeptExtId = '';
    this.selectedDeptID = null;
    this.selectedFormTypeId = null;
    this.selectedAuthorId = '';
    this.selectedAuthorName = '';
    this.selectedAuthorExtId = '';
    this.selectedJobTypeExtId = '';
    this.selectedJobTypeDisplayName = '';
    this.showFormFields = false;
    this.selectedRequestorId = null;
    this.deptfilteredOptions = this.clearDropdownValues();
    this.jobTypefilteredOptions = this.clearDropdownValues();
    this.formTypefilteredOptions = this.clearDropdownValues();
    this.authorfilteredOptions = this.clearDropdownValues();
    this.requestorfilteredOptions = this.clearDropdownValues();
  }
  getUploadIcon(): string {
    return this.canUpload ? "../../../assets/img/icon/create-new-job-btn.png" : "../../../assets/img/icon/create-new-job-dis-btn.png"
  }
  async organizationChangeEvent(event) {
    this.spinner.show();
    this.departmentControl.setValue('');
    this.jobtypeControl.setValue('');
    this.formtypeControl.setValue('');
    this.authorControl.setValue('');
    this.requestorControl.setValue('');
    this.deptfilteredOptions = this.clearDropdownValues();
    this.jobTypefilteredOptions = this.clearDropdownValues();
    this.formTypefilteredOptions = this.clearDropdownValues();
    this.authorfilteredOptions = this.clearDropdownValues();
    this.requestorfilteredOptions = this.clearDropdownValues();
    this.sendOrderToNSWCheck = !!event?.option?.value?.sendOrderToNSW;
    this.isJurisdiction = this.sendOrderToNSWCheck;
    this.isCourtLocation = this.sendOrderToNSWCheck;
    this.isCourtRoom = this.sendOrderToNSWCheck;
    this.isOrderType = this.sendOrderToNSWCheck;
    this.showRecordingTimes = this.sendOrderToNSWCheck;
    if (this.sendOrderToNSWCheck) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);   // remove time
      this.orderDateMin = today;
      this.loadJurisdictions(event.option.value.custExtId);
      this.loadCourtLocations(event.option.value.custExtId);
      asyncScheduler.schedule(() => {
        this.setTimes();
      })

    }
    if (event.option.value.id) {
      let item = event.option.value;
      this.selectedOrganization = event;
      this.selectedOrgExtId = item.custExtId;
      localStorage.setItem('estimationMessage', item.estimationMessage);
      if (item) {
        this.departmentControl.enable({ onlySelf: true });
        await this.loadDepartments(item.custExtId, item.tenantId);
        this.spinner.hide();
      }
      else {
        this.spinner.hide();
      }
    }
  };
  async loadDepartments(OrgExtId, TenantId) {
    this.departmentOptions = [];
    const dept_res = await this.loadDepartmentValues(OrgExtId, TenantId);
    departmentList = this.backendService.getJSONResponse(dept_res).data.departmentList;
    this.DepartmentDetails = departmentList;
    for (let department of this.DepartmentDetails) {
      //TODO: FD
      let data = {
        'id': department.id,
        'name': department.name,
        'deptExtId': department.deptExtId,
        'isFutureOrder': department.isFutureOrder,
        'isForeignLanguage': department.isForeignLanguage,
        'isForeignLanguageFirstDraft': department.isForeignLanguageFirstDraft,
        'isSensitive': department.isSensitive,
        'isCertification': department.isCertification,
        'isNotarization': department.isNotarization,
        'defaultForeignLanguageService': department.defaultForeignLanguageService,
        'defaultSourceForeignLanguage': department.defaultSourceForeignLanguage,
        'allowMultipleJobs': department.allowMultipleJobs,
        'isUploadProgressively': department.isUploadProgressively,
        'orderFormTypes': department.orderFormTypes,
        'deptId': department.deptId
      }
      this.departmentOptions.push(data);
    }
    this.deptfilteredOptions = this.departmentControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value['name']),
        map(name => name ? this.departmentfilter(name) : this.departmentOptions.slice()),
      );
    if (this.departmentOptions.length == 1) {
      this.departmentControl.disable({ onlySelf: true });
      this.departmentControl.setValue(this.departmentOptions[0]);
      this.selectedDepartmentId = this.departmentOptions[0].id;
      this.selectedDeptExtId = this.departmentOptions[0].deptExtId;
      this.selectedDeptID = this.departmentOptions[0].deptId;
      this.departmentSingleOptionChangeEvent(this.departmentOptions[0]);
    }
  }
  loadDepartmentValues(OrgExtId, TenantId) {
    return this.backendService.getDepartmentsByOrganization(OrgExtId, TenantId).toPromise();
  }
  async loadDeparmentValues() {
    this.departmentOptions = [];
    var departmentListDetails = await this.backendService.getDepartments().toPromise();
    let departmentList = this.backendService.getJSONResponse(departmentListDetails['data'].departmentList);
    for (let department of departmentList) {
      //TODO: FD
      let data = {
        'id': department.id,
        'name': department.name,
        'deptExtId': department.deptExtId,
        'isFutureOrder': department.isFutureOrder,
        'isForeignLanguage': department.isForeignLanguage,
        'isForeignLanguageFirstDraft': department.isForeignLanguageFirstDraft,
        'isSensitive': department.isSensitive,
        'isCertification': department.isCertification,
        'isNotarization': department.isNotarization,
        'defaultForeignLanguageService': department.defaultForeignLanguageService,
        'defaultSourceForeignLanguage': department.defaultSourceForeignLanguage,
        'allowMultipleJobs': department.allowMultipleJobs,
        'isUploadProgressively': department.isUploadProgressively,
        'orderFormTypes': department.orderFormTypes,
        'deptId': department.deptId,
        'orgExtId': department.orgExtId,
        'sendOrderToNSW': department.sendOrderToNSW
      }
      this.departmentOptions.push(data);
    }
    this.deptfilteredOptions = this.departmentControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value['name']),
        map(name => name ? this.departmentfilter(name) : this.departmentOptions.slice()),
      );
    if (this.departmentOptions.length == 1) {
      this.departmentControl.setValue(this.departmentOptions[0]);
      this.selectedDepartmentId = this.departmentOptions[0].id;
      this.selectedDeptExtId = this.departmentOptions[0].deptExtId;
      this.selectedDeptID = this.departmentOptions[0].deptId;
      this.selectedOrgExtId = this.departmentOptions[0].orgExtId;
      this.sendOrderToNSWCheck = this.departmentOptions[0].sendOrderToNSW;
      this.departmentSingleOptionChangeEvent(this.departmentOptions[0]);
    }
    this.spinner.hide();
  }
  async loadOrganizations() {
    const orgs_res = await this.loadOrganizationValues();
    this.loadOrgsValuesForDropDown(orgs_res);
  }
  loadOrganizationValues() {
    this.organizationOptions = [];
    return this.backendService.getCustomers().toPromise();
  }
  loadOrgsValuesForDropDown(org_res) {
    this.organizationOptions = [];
    let orgsList = this.backendService.getJSONResponse(org_res).data.customerList;
    for (let org of orgsList) {
      let data = {
        "id": org.id,
        "customerName": org.customerName + ' (' + org.tenantName + ')',
        "custExtId": org.custExtId,
        "directBucket": org.directBucket,
        "dbId": org.dbId,
        "ncurl": org.ncurl,
        "tenantId": org.tenantId,
        "tenantName": org.tenantName,
        "emailTemplateId": org.emailTemplateId,
        "sourceType": org.sourceType,
        "isFutureOrder": org.isFutureOrder,
        "estimationMessage": org.estimationMessage,
        "sendOrderToNSW": org.sendOrderToNSW
      }
      this.organizationOptions.push(data);
    }
    this.organizationfilteredOptions = this.organizationControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value['name']),
        map(name => name ? this.organizationfilter(name) : this.organizationOptions.slice())
      );
  }
  selectMediaFiles() {
    if (this.uploadMediaDialog == null) {
      this.mediaDialogData = new MediaDialogData();
      this.mediaDialogData.ListOfAudioFiles = this.ListOfAudioFiles;
      this.mediaDialogData.ListOfOriginalFiles = ListOfOriginalFiles;
      this.mediaDialogData.originalFile = this.originalFile;
      this.mediaDialogData.canUpload = this.canUpload;
      this.mediaDialogData.FileType = this.FileType;
      this.mediaDialogData.ListzipFiles = ListzipFiles;
      this.mediaDialogData.ListOfAudioFiles1 = this.ListOfAudioFiles1;
      this.mediaDialogData.IsMergeAudios = true;
      this.mediaDialogData.ListOfMergeAudioFiles = ListOfMergeAudioFiles;
      this.mediaDialogData.MergeAudioFileNameList = MergeAudioFileNameList;
      this.mediaDialogData.isUploadProgressively = true;
      this.uploadMediaDialog = this.dialog.open(UploadMediaComponent, {
        width: '82%',
        data: { ref: "media", isjob: false, "data": this.mediaDialogData },
        disableClose: true
      });
      this.uploadMediaDialog.afterClosed().subscribe(result => {
        this.uploadMediaDialog = null;
        if (result != "Clear") {
          this.ListOfAudioFiles = [];
          this.ListOfAudioFiles = result["ListOfAudioFiles"];
          ListOfOriginalFiles = result["ListOfOriginalFiles"];
          this.originalFile = result["originalFile"];
          this.FileType = result["FileType"];
          this.canUpload = result["canUpload"];
          ListzipFiles = result["ListzipFiles"];
          this.ListOfAudioFiles1 = result["ListOfAudioFiles1"];
          this.IsMergeAudios = result["IsMergeAudios"];
          ListOfMergeAudioFiles = result["ListOfMergeAudioFiles"];
          MergeAudioFileNameList = result["MergeAudioFileNameList"];
        }
        this.mediaDialogData = null;
      });
    }
  }
  attachDocuments() {
    if (this.uploadMediaDialog == null) {
      this.attachmentsDialogData = new AttachmentsDialogData();
      this.attachmentsDialogData.ListOfAttachments = this.ListOfAttachments;
      this.attachmentsDialogData.ListOfAttachmentFiles = ListOfAttachmentFiles;
      this.uploadMediaDialog = this.dialog.open(UploadMediaComponent, {
        width: '80%',
        data: { ref: "attachDocs", "data": this.attachmentsDialogData },
        disableClose: true
      });
      this.uploadMediaDialog.afterClosed().subscribe(result => {
        this.uploadMediaDialog = null;
        if (result != "Clear") {
          this.ListOfAttachments = result["ListOfAttachments"];
          ListOfAttachmentFiles = result["ListOfAttachmentFiles"];
        }
        this.attachmentsDialogData = null;
      });
    }
  }
  addNotes() {
    if (this.uploadMediaDialog == null) {
      this.notesDialogData = new NotesDialogData();
      this.notesDialogData.Notes = this.Notes;
      this.uploadMediaDialog = this.dialog.open(UploadMediaComponent, {
        width: '85%',
        data: { ref: "addNotes", isjob: false, customerNotesEnable: false, "data": this.notesDialogData },
        disableClose: true
      });
      this.uploadMediaDialog.afterClosed().subscribe(result => {
        this.uploadMediaDialog = null;
        if (result != "Clear") {
          this.Notes = result["Notes"];
        }
        this.notesDialogData = null;
      });
    }
  }
  calculateEstimate() {
    if (this.uploadMediaDialog == null) {
      this.estimateDialogData = new EstimateDialogData();
      this.selectedIndex = 0;
      this.estimateDialogData.showAcceptButton = true;
      this.estimateDialogData.receiptEmail = this.receiptEmail;
      this.estimateDialogData.totalEstimateAmount = this.totalEstimateAmount;
      this.estimateDialogData.numberOfMins = this.numberOfMins;
      this.estimateDialogData.jobCostMinuteRateEstimation = this.jobCostMinuteRateEstimation;
      this.estimateDialogData.estimateJobTypeDisplayName = this.estimateJobTypeDisplayName;
      this.estimateDialogData.estimateJobTypeExtId = this.estimateJobTypeExtId;
      this.estimateDialogData.selectedIndex = this.selectedIndex;
      this.uploadMediaDialog = this.dialog.open(UploadMediaComponent, {
        width: '45%',
        data: { ref: "estimate", "data": this.estimateDialogData },
        disableClose: true
      });
      this.uploadMediaDialog.afterClosed().subscribe(result => {
        this.uploadMediaDialog = null;
        if (result != "Clear") {
          this.totalEstimateAmount = result["totalEstimateAmount"];
          this.numberOfMins = result["numberOfMins"];
          this.jobCostMinuteRateEstimation = result["jobCostMinuteRateEstimation"];
          this.receiptEmail = result["receiptEmail"];
          this.estimateJobTypeDisplayName = result["estimateJobTypeDisplayName"];
          this.estimateJobTypeExtId = result["estimateJobTypeExtId"];
          this.selectedIndex = result["selectedIndex"];
        }
        this.estimateDialogData = null;
      });
    }
  }
  isNotes(): boolean {
    if (this.Notes) {
      return true;
    }
    return false;
  }
  private organizationfilter(name: any): Organizations[] {
    const filterValue = name.toLowerCase();
    return this.organizationOptions.filter(option => option.customerName.toLowerCase().indexOf(filterValue) === 0);
  }
  private orderTypefilter(name: any) {
    const filterValue = name.toLowerCase();
    return this.orderTypes.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }
  getListOfAudioFiles(): number {
    return this.ListOfAudioFiles.length ? this.ListOfAudioFiles.length : 0;
  }
  getListOfAttachmentFiles(): number {
    return this.ListOfAttachments.length ? this.ListOfAttachments.length : 0;
  }
  removeJobAudioFiles() {
    this.ListOfAudioFiles1 = [];
    Audiofile = new FileToUpload();
  }
  removeFileByName(fileName) {
    if (this.IsMergeAudios == true) {
      this.remove();
    }
    else {
      var ListAfterRemove = [];
      ListOfOriginalFiles.forEach(filedetails => {
        if (filedetails.name == fileName) {
        }
        else {
          ListAfterRemove.push(filedetails);
        }
      });
      ListOfOriginalFiles = ListAfterRemove;
      this.ListOfAudioFiles = ListOfOriginalFiles;
      if (this.ListOfAudioFiles.length == 0) {
        ListOfOriginalFiles = [];
        ListzipFiles = [];
      }
      this.file = null;
      this.originalFile = null;
    }
  }
  removeJobAttachments() {
    this.ListOfAttachments = [];
    Attachmentfile = new FileToUpload();
    ListOfZippedDocuments = [];
  }
  removeAttachmentByName(fileName) {
    var ListofAttachmentsAfterRemove = [];
    this.ListOfAttachments.forEach(filedetails => {
      if (filedetails.fileName == fileName) {
      }
      else {
        ListofAttachmentsAfterRemove.push(filedetails);
      }
    });
    this.ListOfAttachments = ListofAttachmentsAfterRemove;
    ListOfZippedDocuments = ListofAttachmentsAfterRemove;
    this.resetFileUploader();
  }
  resetFileUploader() {
    if (this.fileUploader) {
      this.fileUploader.nativeElement.value = null;
    }
  }
  isEstimate(): boolean {
    return (this.totalEstimateAmount) ? true : false;
  }
  ngOnDestroy() {
    localStorage.setItem('estimationMessage', null);
  }
  async loadgetorderstatuses() {

    this.backendService.getorderstatuses().subscribe(
      res => {
        this.orderStatusesOptions = res;
        this.spinner.hide();
      },
      err => {
        const er = this.backendService.getJSONResponse(err);
      }
    );
  }
  private filterOrderTypes(value: string | dropdownmodel): dropdownmodel[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : value?.name.toLowerCase();
    return this.orderTypeList.filter(option => option.name.toLowerCase().includes(filterValue));
  }
  async loadJurisdictions(orgExtId) {
    const juris_res = await this.loadJurisdictionsValues(orgExtId);
    //console.log('juris_res : :',juris_res)
    this.loadJurisdictionsValuesForDropDown(juris_res);
  }
  loadJurisdictionsValues(orgExtId) {
    this.jurisdictionOptions = [];
    return this.backendService.getJurisdictions(orgExtId).toPromise();
  }
  loadJurisdictionsValuesForDropDown(juris_res) {
    this.jurisdictionOptions = [];
    let jurisList = this.backendService.getJSONResponse(juris_res).data.result;
    //console.log("jurisList:::",jurisList);
    for (let jur of jurisList) {
      let data = {
        "id": jur.id,
        "name": jur.name,
        "externalId": jur.externalId
      }
      this.jurisdictionOptions.push(data);
    }
    if (this.jurisdictionOptions.length == 0) {
      this.sendNotification('No jurisdictions in netScribe for this organization.', 'error')
    }
    else {
      this.jurisdictionfilteredOptions = this.jurisdictionControl.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value['name']),
          map(name => name ? this.jurisdictionfilter(name) : this.jurisdictionOptions.slice())
        );
    }
  }
  private jurisdictionfilter(name: any): Jurisdictions[] {
    const filterValue = name.toLowerCase();
    return this.jurisdictionOptions.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }
  async loadCourtLocations(orgExtId) {
    const courtlocs_res = await this.loadCourtLocationsValues(orgExtId);
    this.loadCourtLocationsValuesForDropDown(courtlocs_res);
  }
  loadCourtLocationsValues(orgExtId) {
    this.courtlocationsOptions = [];
    return this.backendService.getCourtLocations(orgExtId).toPromise();
  }
  loadCourtLocationsValuesForDropDown(courtlocs_res) {
    this.courtlocationsOptions = [];
    let courtlocsList = this.backendService.getJSONResponse(courtlocs_res).data.result;
    for (let cl of courtlocsList) {
      let data = {
        "id": cl.id,
        "name": cl.name,
        "address": cl.address,
        "comment": cl.comment,
        "externalId": cl.externalId
      }
      this.courtlocationsOptions.push(data);
    }
    if (this.courtlocationsOptions.length == 0) {
      this.sendNotification('No courtlocations in netScribe for this organization.', 'error')
    }
    else {
      this.courtLocationfilteredOptions = this.courtLocationControl.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value['name']),
          map(name => name ? this.courtLocationsfilter(name) : this.courtlocationsOptions.slice())
        );
    }
  }
  private courtLocationsfilter(name: any): CourtLocations[] {
    const filterValue = name.toLowerCase();
    return this.courtlocationsOptions.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }
  async loadCourtRooms(id) {
    const courtrooms_res = await this.loadCourtRoomsValues(this.selectedOrgExtId, id);
    this.loadCourtRoomsValuesForDropDown(courtrooms_res);
  }
  loadCourtRoomsValues(orgExtId, id) {
    this.courtRoomsOptions = [];
    return this.backendService.getCourtRooms(orgExtId, id).toPromise();
  }
  loadCourtRoomsValuesForDropDown(courtrooms_res) {
    this.courtRoomsOptions = [];
    let courtroomsList = this.backendService.getJSONResponse(courtrooms_res).data.result;
    for (let cr of courtroomsList) {
      let data = {
        "id": cr.id,
        "name": cr.name,
        "externalId": cr.externalId
      }
      this.courtRoomsOptions.push(data);
    }
    if (this.courtRoomsOptions.length == 0) {
      this.sendNotification('No courtRooms in netScribe for this courtlocation.', 'error')
    }
    else {
      this.courtRoomfilteredOptions = this.courtRoomControl.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value['name']),
          map(name => name ? this.courtRoomsfilter(name) : this.courtRoomsOptions.slice())
        );
    }
  }
  private courtRoomsfilter(name: any): CourtRooms[] {
    const filterValue = name.toLowerCase();
    return this.courtRoomsOptions.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }
  // ✅ SAFE TIME FORMATTER
  private formatTime(date: Date): string {
    if (!date) return '00:00';

    const normalized = new Date(); // today's date
    normalized.setHours(date.getHours(), date.getMinutes(), 0, 0);

    return normalized.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  }

  // ✅ SAFE TIME PARSER
  private parseTime(timeStr: string): Date {
    const [h, m] = timeStr.split(':').map(Number);
    const d = new Date();
    d.setHours(h, m, 0, 0);
    return d;
  }

  private refreshListBox() {
    this.timeListSource = this.recordingTimes.map((t, i) => ({
      label: `${t.StartTime} - ${t.EndTime}`,
      value: i
    }));
  }

  addTimeRange() {
    const startRaw = this.startDateTime.getDate();
    const endRaw = this.endDateTime.getDate();

    if (!startRaw || !endRaw) {
      this.sendNotification('Please select both Start and End time', 'error');
      return;
    }

    const start = new Date(startRaw);
    const end = new Date(endRaw);

    const startMin = start.getHours() * 60 + start.getMinutes();
    const endMin = end.getHours() * 60 + end.getMinutes();

    if (startMin === endMin) {
      this.sendNotification('Start time and End time cannot be the same', 'error');
      return;
    }

    if (endMin < startMin) {
      this.sendNotification('End time must be after Start time', 'error');
      return;
    }
    if (this.hasOverlap(startMin, endMin)) {
      this.sendNotification('Time range overlaps with existing recording', 'error');
      return;
    }
    const isDuplicate = this.recordingTimes.some((t, i) => {
      if (i === this.selectedTimeIndex) return false;

      const [sh, sm] = t.StartTime.split(':').map(Number);
      const [eh, em] = t.EndTime.split(':').map(Number);

      const existingStart = sh * 60 + sm;
      const existingEnd = eh * 60 + em;

      return existingStart === startMin && existingEnd === endMin;
    });

    if (isDuplicate) {
      this.sendNotification('This time range already exists', 'error');
      return;
    }
    this.recordingTimes.push({
      StartTime: this.formatTime(start),
      EndTime: this.formatTime(end)
    });

    this.refreshListBox();
    this.cancelEdit();
  }

  onTimeSelect(event: any) {
    this.selectedTimeIndex = event.args.item.value;
    // const item = this.recordingTimes[this.selectedTimeIndex];

    // this.startDateTime.setDate(this.parseTime(item.StartTime));
    // this.endDateTime.setDate(this.parseTime(item.EndTime));
    if (this.isEditTimeMode) {
      this.cancelEdit();
    }
  }

  updateTimeRange() {
    if (this.selectedTimeIndex === null) return;

    const startRaw = this.startDateTime.getDate();
    const endRaw = this.endDateTime.getDate();

    if (!startRaw || !endRaw) {
      this.sendNotification('Please select both Start and End time', 'error');
      return;
    }

    const start = new Date(startRaw);
    const end = new Date(endRaw);

    const startMin = start.getHours() * 60 + start.getMinutes();
    const endMin = end.getHours() * 60 + end.getMinutes();

    if (startMin === endMin) {
      this.sendNotification('Start time and End time cannot be the same', 'error');
      return;
    }

    if (endMin < startMin) {
      this.sendNotification('End time must be after Start time', 'error');
      return;
    }
    if (this.hasOverlap(startMin, endMin, this.selectedTimeIndex)) {
      this.sendNotification('Time range overlaps with existing recording', 'error');
      return;
    }

    const isDuplicate = this.recordingTimes.some((t, i) => {
      if (i === this.selectedTimeIndex) return false;

      const [sh, sm] = t.StartTime.split(':').map(Number);
      const [eh, em] = t.EndTime.split(':').map(Number);

      const existingStart = sh * 60 + sm;
      const existingEnd = eh * 60 + em;

      return existingStart === startMin && existingEnd === endMin;
    });

    if (isDuplicate) {
      this.sendNotification('This time range already exists', 'error');
      return;
    }
    this.recordingTimes[this.selectedTimeIndex] = {
      StartTime: this.formatTime(start),
      EndTime: this.formatTime(end)
    };

    this.refreshListBox();
    this.cancelEdit();
  }


  deleteTimeRange() {
    if (this.selectedTimeIndex === null) return;

    this.recordingTimes.splice(this.selectedTimeIndex, 1);
    this.refreshListBox();
    this.selectedTimeIndex = null;
    this.isEditTimeMode = false;
  }


  cancelEdit() {
    this.isEditTimeMode = false;
    this.setTimes();
  }
  setTimes() {
    const start = new Date();
    start.setHours(0, 0, 0, 0);   // 00:00:00

    const end = new Date();
    end.setHours(23, 59, 0, 0);  // 23:59:00

    this.startDateTime.setDate(start);
    this.endDateTime.setDate(end);
  }

  handleReorder() {
    const items = this.timeList.getItems();
    this.recordingTimes = items.map((item: any) => {
      const [start, end] = item.label.split(' - ');
      return { StartTime: start, EndTime: end };
    });
    this.refreshListBox();
  }

  // 🚀 Backend Payload
  getPayload() {
    return {
      recordingTimes: JSON.stringify(this.recordingTimes)
    };
  }
  editTimeRange() {
    if (this.selectedTimeIndex === null) {
      this.sendNotification('Select a time range first', 'error');
      return;
    }

    const item = this.recordingTimes[this.selectedTimeIndex];
    this.startDateTime.setDate(this.parseTime(item.StartTime));
    this.endDateTime.setDate(this.parseTime(item.EndTime));

    this.isEditTimeMode = true;
  }
  hasOverlap(startMin: number, endMin: number, ignoreIndex: number | null = null): boolean {
    return this.recordingTimes.some((t, i) => {
      if (i === ignoreIndex) return false;
      const [sh, sm] = t.StartTime.split(':').map(Number);
      const [eh, em] = t.EndTime.split(':').map(Number);
      const existingStart = sh * 60 + sm;
      const existingEnd = eh * 60 + em;
      return startMin < existingEnd && endMin > existingStart;
    });
  }
  timeToMinutes(time: string): number {
    const [h, m] = time.split(':').map(Number);
    return h * 60 + m;
  }
  clearCourtOrderFields()
  {
    this.orderDate=null;
    this.jurisdictionControl.setValue('');
    this.jurisdictionOptions = [];
    this.loadJurisdictions(this.selectedOrgExtId);
    this.courtLocationControl.setValue('');
    this.courtlocationsOptions=[];
    this.loadCourtLocations(this.selectedOrgExtId)
    this.courtRoomControl.setValue('');
    this.courtRoomControl.disable({ onlySelf: true });
    this.orderTypeControl.setValue(null);
    this.selectedorderTypeId=null;
    this.orderTypeList=[];
    this.orderTypeList =  [
    {
      id: '1',
      name: 'Daily',
      orderFormTypes: 'DAILY',
      formName: 'Daily Order'
    },
    {
      id: '2',
      name: 'Delayed',
      orderFormTypes: 'Delayed',
      formName: 'Delayed Order'
    }
  ];
    this.orderTypefilteredOptions = this.orderTypeControl.valueChanges.pipe(
      startWith(''),
      map(value => this.filterOrderTypes(value))
    );
    this.orderCreationForm.get('caseNumber')?.setValue('');
    this.orderCreationForm.get('language')?.setValue('');
    this.myOrderDateTimeInput.val(new Date());
    this.myDateTimeInput.val(new Date());
    this.selectedjurisdicationExtId=null;
    this.selectedcourtLocationExtId=null;
    this.selectedcourtRoomExtId=null;
    this.selectedorderTypeId = null;
    this.recordingTimes=[];
    this.timeListSource = [];
  }
}
